/**
 * sessionStorage key used to stash the attempted campaign deep-link
 * (e.g. "/rewards?campaign=5kg") when AuthGuardService bounces a logged-out
 * user to /session/signin. AuthGuardService's redirect is a hard page
 * navigation (window.open(..., "_self")), which wipes AuthService's
 * in-memory redirectUrl, so the pending destination has to survive in
 * sessionStorage instead. Consumed once (read + cleared) by AuthService
 * after login/registration completes.
 */
export const CAMPAIGN_REDIRECT_STORAGE_KEY = "fms_campaign_redirect_url";
